import { Component, OnInit, Input } from '@angular/core';
import { IstSummaryService } from '../../../../services/ist/ist-summary.service';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { Subject } from 'rxjs';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModuleMenu, SCREEN_RESPONSE, ScreenResponseModel } from '../../../../models/common';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-ist-study-team-add-or-role',
  templateUrl: './ist-study-team-add-or-role.component.html',
  styleUrls: ['./ist-study-team-add-or-role.component.scss']
})
export class IstStudyTeamAddOrRoleComponent implements OnInit {

  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  organizationOptions = [];
  roleOptions = [];
  ApplicationID: any;
  RoleName: string = "";
  MemberOrganizationName: string = "";
  organizationgrayout: boolean = true;
  staticformFields: any;
  Application_Type_ID: string = "";
  menudata: ModuleMenu;
  IsFormToched: boolean = false;
  submittedresponse: SCREEN_RESPONSE[] = [];
  permission: any;

  constructor(public modalRef: NgbActiveModal,
    private summaryService: IstSummaryService,
    private istDatashareserivse: IstDataShareService,
    private commonservice: CommonService,
    public datepipe: DatePipe,
  ) { }

  ngOnInit() {
    this.istDatashareserivse.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.istDatashareserivse.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
    if (this.Content?.content?.staticformFields && this.Content?.content?.staticformFields?.length > 0) {
      this.staticformFields = this.Content.content.staticformFields;
      this.staticformFields.forEach((item) => {
        item.ControlValue = ""
      });
    }
    else {
      this.GetScreenConfigControls('SCR-002');
    }
    this.bindData();
    this.GetMasterData();
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonservice.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      if (this.staticformFields && this.staticformFields.length > 0) {
        this.staticformFields = this.staticformFields.filter(x => x.FIELD_CODE == 'StudyTeam_Org' || x.FIELD_CODE == 'StudyTeam_UserRole');
      }
      this.bindData();
    });
  }

  GetMasterData() {
    this.summaryService.masterData("api/ISTStudyTeam/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(summary => {
      this.roleOptions = summary["MasterData2"];
    //  this.roleOptions = [{ label: "Select", value: "", checked: true }].concat(this.roleOptions);
      this.organizationOptions = summary["MasterData1"];
     // this.organizationOptions = [{ label: "Select", value: "", checked: true }].concat(this.organizationOptions);
    });
  }

  bindData() {
    if (this.Content.heading == "view" || this.Content.heading == "Edit") {
      this.BindDataToDynamicControls();
      this.BindDataToStaticControls(this.Content?.content);
    }
    else {
      this.organizationgrayout = false;
    }
    this.BuildDropdownList();
  }

  BuildDropdownList() {
    if (this.staticformFields && this.staticformFields.length > 0) {
      this.organizationOptions = this.staticformFields.find(x => x.FIELD_CODE == 'StudyTeam_Org').GROUP_VALUES_LIST;
      this.roleOptions = this.staticformFields.find(x => x.FIELD_CODE == 'StudyTeam_UserRole').GROUP_VALUES_LIST;
    }
  }

  getOrganizationName(event) {
    this.MemberOrganizationName = ""
    let id = event.value;
    let obj = this.organizationOptions.filter(function (item) {
      return item.value == id;
    })[0];
    if (obj != null && obj != undefined && obj != "") {
      this.MemberOrganizationName = obj.label;
    }
  }

  getRoleName(event) {
    this.RoleName = "";
    let id = event.value;
    let obj = this.roleOptions.filter(function (item) {
      return item.value == id;
    })[0];
    if (obj != null && obj != undefined && obj != "") {
      this.RoleName = obj.label;
    }

  }

  SaveRoleOrgMap() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        let memId: any;
        let roleId: any;
        let orgLabel = "Organization";
        let roleLabel = "User Role";
        this.staticformFields?.forEach((item) => {
          if (item.FIELD_CODE == 'StudyTeam_Org') {
            orgLabel = item.LABEL;
            if (this.organizationOptions && this.organizationOptions.length > 0 && item.ControlValue) {
              memId = this.organizationOptions.find(x => x.value == item.ControlValue).value ?? "";
            }
            else {
              memId = null;
            }
          }
          else if (item.FIELD_CODE === 'StudyTeam_UserRole') {
            roleLabel = item.LABEL;
            if (this.roleOptions && this.roleOptions.length > 0 && item.ControlValue) {
              roleId = this.roleOptions.find(x => x.value == item.ControlValue).value ?? "";
            }
            else {
              roleId = null;
            }
          }
        })

        let isOrgExist = this.Content.content.rowDataRoles.filter(
          (r: any) => { return r.MemberOrganizationId == memId && r.RoleId == roleId })[0];
        if (isOrgExist != null && isOrgExist!=undefined) {
          let message = "";
          if (this.Content?.heading != "Edit") {
            message +=  "A role "+ roleLabel  +" is already added against this " + orgLabel + ". Please select another role <br/>";
            this.commonservice.ValidationBanner(message);
          }
          else {
            let isOrgDExist = this.Content.content.rowDataRoles.findIndex(
              (r: any) => r.MemberOrganizationId == memId && r.RoleId == roleId);
            if (isOrgDExist != -1) {
              this.modalRef.dismiss();
            }
            else {
              let obj = {
                "MemberOrganizationId": memId, "MemberOrganizationName": this.MemberOrganizationName,
                "RoleId": roleId, "RoleName": this.RoleName
              };
              this.modalRef.close(obj);
            }
          }
        }
        else {
          let obj = {
            "MemberOrganizationId": memId,
            "MemberOrganizationName": this.MemberOrganizationName,
            "RoleId": roleId,
            "RoleName": this.RoleName
          };
          this.modalRef.close(obj);
        }
      }
    }
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
          case 2:
          case 3:
          case 5:
          case 4:
          case 11:
          case 10:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please select ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 7:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });
    if (!isValid)
      this.commonservice.ValidationBanner(message);
    return isValid;
  }


  Close() {
    this.canExit().then((x) => {
      this.modalRef.dismiss();
    });
  }

  canExit() {
    if (this.IsFormToched && this.Content.heading == 'Edit') {
      return this.commonservice.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }


  singleonChange($event, question) {
    this.IsFormToched = true;
    if (question.FIELD_CODE == 'StudyTeam_Org') {
      this.getOrganizationName($event)
    }
    else if (question.FIELD_CODE == 'StudyTeam_UserRole') {
      this.getRoleName($event)
    }

    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question);
  }

  ApplyConditions($event, question) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];


    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })


    //default
    if (value != "") {
      if (this.staticformFields) {
        this.staticformFields.forEach((con) => {

          if (displayControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Display = true;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (hideControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Display = false;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (enableControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Enabled = true;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (disbledControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Enabled = false;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
        });
      }
    }
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })
    if (this.staticformFields) {
      this.staticformFields.forEach((con) => {
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
        }
      });
    }
  }


  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-003";
      sr.RowId = this.Content?.content?.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (var i = 0; i < this.staticformFields?.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }
                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;
                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonservice.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }
                }
              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
              }
            }

          }
        }
      });
    }
  }

  BindDataToStaticControls(MainObjData: any): any {
    for (let i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "StudyTeam_Org":
          this.staticformFields[i].ControlValue = MainObjData.MemberOrganizationId;
          break;
        case "StudyTeam_UserRole":
          this.staticformFields[i].ControlValue = MainObjData.RoleId;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
      }
    }
    this.MemberOrganizationName = MainObjData.OrganizationName;
    this.RoleName = MainObjData.RoleName;
    this.organizationgrayout = true;

  }


}
